export const aboutData = {
  title: "Who I am",
  description1:
    "A Results-Driven Frontend Engineer from India with a passion for building high-performance web solutions and streamlining processes through automation.",
  description2: `Specialize in crafting efficient, scalable software architectures that address complex challenges while driving innovation and tangible business outcomes.
    With a proven track record of delivering high-performance web solutions, I combine technical expertise with strategic problem-solving to drive organizational innovation.
<br/><br/>
    My professional philosophy centers on continuous learning, process automation, and delivering innovative technological solutions. I'm passionate about transforming complex challenges into elegant, efficient software architectures that drive tangible business value.
    <br/><br/>
    Currently open to full-time and freelance opportunities in Software Engineering, Web Development, and emerging technology domains.`,
  image: 2,
};
